// The entry point for bundle.js
// NOTE: for now there's only one bundle.js, but in a future there will be many.

import "cropperjs/dist/cropper.css";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import ReactModal from "react-modal";

import * as components from "./components";
import { getSingletonStore } from "./components/stores/store";
import { createElement } from "./utils/createElement";

import "./initialize";
import "./jquery/apply_markdown_helper";
import "./jquery/confirm_dialog";
import "./jquery/policy_confirmation_checkbox";
import "./polyfills/MediaQuery.addEventListener";
import "./mathjax/auto_apply";
import "./registerServiceWorker";
import "./utils/dashboard";
import { UnicodeEmojiElement } from "~/client/elements/unicode-emoji-element";
import { kibelaContext } from "~/client/utils/kibelaContext";

if (process.env.NODE_ENV === "development") {
  import("show-js-error");
}

const renderReactComponentsWithCsr = () => {
  const componentNodeList = document.querySelectorAll<HTMLDivElement>(".js-react-component");

  for (const node of componentNodeList) {
    const name = node.dataset.name!;
    const componentPromise = components.map[name]();
    const props = JSON.parse(node.querySelector("script")!.textContent!);
    const root = createRoot(node);

    componentPromise.then((componentModule) => {
      const component = componentModule[name] || componentModule.default;
      root.render(createElement(component, props, getSingletonStore()));
      console.log(`${name} component has been rendered (Hypernova disabled)`);
    });
  }
};

$(() => {
  renderReactComponentsWithCsr();

  ReactModal.setAppElement(document.body);

  window.customElements.define("k-unicode-emoji", UnicodeEmojiElement, { extends: "span" });
});

console.log(`loaded bundle.js (NODE_ENV=${process.env.NODE_ENV})`, kibelaContext);
